module.exports = __webpack_public_path__ + "static/img/zhihui.f9e26ee3.jpg";